const translations = {
    search: 'Select roles'
};

export default translations;
